import React, { useState, useEffect } from "react";
import { FaCheckCircle, FaTimesCircle, FaPencilAlt, FaClock } from "react-icons/fa";
import axios from "../../../axiosInstance"; // Assuming axios instance is configured
import "./Dashboard_admin.css"; // Your custom CSS
import Sidebar_admin from "../Sidebar_Admin/Sidebar_admin";

function Dashboard_admin() {
  const [counts, setCounts] = useState({
    published: 0,
    rejected: 0,
    drafts: 0,
    approvalpending: 0,
  });
  const [views, setViews] = useState({
    totalViews: 0,
    viewsToday: 0,
    viewsThisMonth: 0,
  });
  const [reporters, setReporters] = useState({
    total: 0,
    active: 0,
    rejected: 0,
    pending: 0,
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token"); // JWT token from localStorage

  useEffect(() => {
    const fetchCountsAndViews = async () => {
      try {
        // Ensure to send the token in headers
        const response = await axios.get("/api/dashboard/readall", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Assuming response contains counts, reporters, and views as expected
        setCounts(response.data.counts);
        setViews(response.data.views);
        setReporters(response.data.reporters);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false); // Stop loading once data is fetched
      }
    };

    fetchCountsAndViews(); // Fetch data when component mounts
  }, [token]); // Re-run only when token changes

  return (
    <div>
      <Sidebar_admin />

      <div className="dashboard-container">
        <div className="dashboard-content">
          <h1 className="dashboard-title">Dashboard</h1>

          {loading ? (
            <div className="loading-spinner">
              <p>Loading...</p>
            </div>
          ) : (
            <>
              <div className="dashboard-stats">
                <div className="stat-card">
                  <FaCheckCircle className="stat-icon-1" />
                  <h3>Published</h3>
                  <p>{counts.published}</p>
                </div>
                <div className="stat-card">
                  <FaTimesCircle className="stat-icon-2" />
                  <h3>Rejected</h3>
                  <p>{counts.rejected}</p>
                </div>
                <div className="stat-card">
                  <FaPencilAlt className="stat-icon-3" />
                  <h3>Drafts</h3>
                  <p>{counts.drafts}</p>
                </div>
                <div className="stat-card">
                  <FaClock className="stat-icon-3" />
                  <h3>Approval Pending</h3>
                  <p>{counts.approvalpending}</p>
                </div>
              </div>

              <div className="views-section">
                <h3>Views Status</h3>
                <div className="views-display">
                  <div className="views-box">
                    <h4>Total Views</h4>
                    <p>{views.totalViews}</p>
                  </div>
                  <div className="views-box">
                    <h4>Month Views</h4>
                    <p>{views.viewsThisMonth}</p>
                  </div>
                  <div className="views-box">
                    <h4>Today Views</h4>
                    <p>{views.viewsToday}</p>
                  </div>
                </div>
              </div>

              <div className="reporter-status-section">
                <h3>Reporter Status</h3>
                <div className="reporter-status-display">
                  <div className="reporter-box">
                    <h4>Total Reporters</h4>
                    <p>{reporters.total}</p>
                  </div>
                  <div className="reporter-box">
                    <h4>Active Reporters</h4>
                    <p>{reporters.active}</p>
                  </div>
                  <div className="reporter-box">
                    <h4>Pending Reporters</h4>
                    <p>{reporters.pending}</p>
                  </div>
                  <div className="reporter-box">
                    <h4>Rejected Reporters</h4>
                    <p>{reporters.rejected}</p>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Dashboard_admin;
